import {FC, HTMLAttributes} from 'react';
import clsx from 'clsx';
import {truncateLabel} from 'utils/functions';

export type PillColor =
    | 'grey'
    | 'green'
    | 'gold'
    | 'coral'
    | 'blue'
    | 'orange'
    | 'lime'
    | 'pink';

const PillColors: Record<PillColor, string> = {
    blue: 'bg-blue-100 text-blue-700 ',
    coral: 'bg-coral-100 text-coral-800 ',
    gold: 'bg-gold-100 text-gold-900 ',
    green: 'bg-green-100 text-green-800  ',
    grey: 'bg-grey-200 text-grey-700 ',
    lime: 'bg-decorative-lime-100 text-decorative-lime-800',
    orange: 'bg-decorative-orange-100 text-decorative-orange-700',
    pink: 'bg-decorative-pink-100 text-decorative-pink-800 ',
};

type PillProps = HTMLAttributes<HTMLDivElement> & {
    color: PillColor;
    label: string;
};

const Pill: FC<PillProps> = ({className, color, label, onClick, ...props}) => (
    <div className="flex">
        <div
            className={clsx(
                'flex items-center rounded-full text-sm font-semibold transition-all',
                onClick ? 'pl-2' : 'px-2',
                PillColors[color],
                className,
            )}
            role="complementary"
            {...props}
        >
            {truncateLabel(label)}
        </div>
    </div>
);
export default Pill;
